import React from "react";
import styles from "../styles/skills.module.css";

const Skills = () => {
  return (
    <div className={styles.skills}>
      <h1>Tech Stack</h1>
      <div className={styles.techIcon}>
        <div className={styles.techIcons}>
          <img
            src="https://cdn-icons-png.flaticon.com/128/174/174854.png"
            alt="Tech Stack"
          />
          <img
            src="https://cdn-icons-png.flaticon.com/128/732/732190.png"
            alt="Tech Stack"
          />
          <img
            src="https://cdn-icons-png.flaticon.com/128/5968/5968292.png"
            alt="Tech Stack"
          />
          <img
            src="https://cdn-icons-png.flaticon.com/128/3459/3459528.png"
            alt="Tech Stack"
          />
          <img
            src="https://img.icons8.com/?size=48&id=71257&format=png"
            alt="Tech Stack"
          />
          <img
            src="https://img.icons8.com/?size=160&id=b6vIINYN0kfW&format=png"
            alt="Tech Stack"
          />
        </div>
        <div className={styles.techIcons}>
          <img
            src="https://cdn-icons-png.flaticon.com/128/5968/5968381.png"
            alt="Tech Stack"
          />
          <img
            src="https://img.icons8.com/?size=96&id=x7XMNGh2vdqA&format=png"
            alt="Tech Stack"
          />
          <img
            src="https://img.icons8.com/?size=96&id=hsPbhkOH4FMe&format=png"
            alt="Tech Stack"
          />
          <img
            src="https://img.icons8.com/?size=160&id=8rKdRqZFLurS&format=png"
            alt="Tech Stack"
          />
          <img
            src="https://img.icons8.com/?size=96&id=87330&format=png"
            alt="Tech Stack"
          />
          <img
            style={{ filter: "invert(1)" }}
            src="https://img.icons8.com/?size=100&id=kg46nzoJrmTR&format=png"
            alt="Tech Stack"
          />
        </div>
        <div className={styles.techIcons}>
          <img
            style={{ filter: "invert(1)" }}
            src="https://img.icons8.com/?size=96&id=yUdJlcKanVbh&format=png"
            alt="Tech Stack"
          />
          <img
            src="https://img.icons8.com/?size=96&id=TpULddJc4gTh&format=png"
            alt="Tech Stack"
          />
          <img
            src="https://cdn-icons-png.flaticon.com/128/5968/5968342.png"
            alt="Tech Stack"
          />
          <img
            src="https://cdn-icons-png.flaticon.com/128/14777/14777106.png"
            alt="Tech Stack"
          />
          <img
            src="https://cdn-icons-png.flaticon.com/128/5968/5968350.png"
            alt="Tech Stack"
          />
        </div>
      </div>
    </div>
  );
};

export default Skills;
